<template>
  <button
    v-bind="$attrs"
    class="uk-button"
    :class="[Color, Disabled]"
    :disabled="disabled"
    type="button"
    v-on="$listeners"
  >
    {{ name }}
    <slot v-if="!name"></slot>
  </button>
</template>

<script>
const BasePrefixClass = 'uk-button-'
const ButtonColor = {
  red: 'danger',
  default: 'default'
}

export default {
  name: 'b-button',
  props: {
    name: {
      type: String
    },
    color: {
      type: String,
      default: 'default'
    },
    outline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    Color() {
      return (
        BasePrefixClass + (this.outline ? 'bordered-' : '') + ButtonColor[this.color.toLowerCase()]
      )
    },
    Disabled() {
      return {'uk-button-disabled': this.disabled}
    }
  }
}
</script>

<style lang="scss" scoped>
.uk-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-weight: 500;
  font-size: 1.25rem;
  text-transform: none;
  border-radius: 10px;
  white-space: nowrap;

  &-danger {
    background: #e31e24;
    border: 1px solid #e31e24;
  }

  &-default {
    font-weight: normal;
    font-size: 1.125rem;
    color: rgba(34, 34, 34, 0.4);
  }

  &-bordered-danger {
    background: none;
    color: #e31e24;
    border: 1px solid #e31e24;
    transition: opacity 0.2s ease-out;

    &:hover {
      opacity: 0.7;
    }
  }

  &-disabled,
  &-disabled:hover {
    background-color: #8a8a8a;
    color: #fff;
    border: 1px solid #8a8a8a;
  }
}
</style>
